<template>
    <div>
        <div class="h1">
            <div class="ww">
                <div class="li-1">
                    <div class="qwer">
                        <input type="text" v-model="name" placeholder="请输入您支付订金的付款姓名">
                    </div>
                </div>
                <div class="li-2" style="margin-top: .18rem;margin-bottom: .28rem;"><span>注：与付款姓名一致，必填</span></div>
                <div class="li-1">
                    <div class="qwer">
                        <input type="text" v-model="phone" placeholder="请输入您的手机号">
                    </div>
                </div>
                <div class="li-2" style="margin-top: .18rem;"><span>11位手机号，必填</span></div>
                <div class="li-3 " @click="receive">
                    <img src="../../assets/img/market/market103/btn.png" alt="">
                </div>
                <div class="li-4">此券为股多多老用户专享，每位用户限领1张（全国限量500张）</div>
            </div>
        </div>


        <div class="divBG" v-if="tan" @click="tanss">
            <div class="content">
                <img class="btnss" src="../../assets/img/market/market103/shibai.png" alt="" />
            </div>
        </div>


    </div>
</template>

<script>

export default {
    data() {
        return {
            phone: "",
            name: "",
            tan: false
        };
    },

    mounted() {

    },
    methods: {
        tanss() {
            if (this.tan == true) {
                this.tan = false;
            } else {
                this.tan = true;
            }
        },
        receive() {
            var re = /^1[3-9]{1}[0-9]{9}$/;;
            if (re.test(this.phone)) {
                // this.$router.push({ path: "/market103_success" });
                this.tan = true;

            } else {
                alert("请输入正确格式的手机号")
                this.phone = ""
            }
        }

    }
};
</script>
<style lang="less" scoped>
* {
    font-size: 16px;
}

.divBG {
    z-index: 999;
    background-color: rgba(31, 30, 30, 0.6);
    position: fixed;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    z-index: 20;

    .content {
        width: 1rem;
        margin: 0 auto;
        position: relative;

        .btnss {
            position: absolute;
            top: 5rem;
            left: -2.7rem;
            z-index: 999;
            width: 6.46rem;
            height: 3.24rem;
        }

    }


}

.h1 {
    width: 100%;
    height: 12rem;
    background: url(../../assets/img/market/market103/bg.png);
    background-size: 100% 100%;

    .ww {
        padding-top: 4.7rem;

        input {
            background: none;
            outline: none;
            border: none;
            width: 6rem;
            height: .96rem;
        }

        .li-1 {

            margin: 0 auto;
            width: 7.02rem;
            height: .96rem;
            border: 2px solid #F74976;
            border-radius: .05rem;

            .qwer {
                padding-left: 1rem;

                ::-webkit-input-placeholder {
                    /* WebKit browsers */
                    color: #F74976;
                }

                :-moz-placeholder {
                    /* Mozilla Firefox 4 to 18 */
                    color: #F74976;
                }

                ::-moz-placeholder {
                    /* Mozilla Firefox 19+ */
                    color: #F74976;
                }

                :-ms-input-placeholder {
                    /* Internet Explorer 10+ */
                    color: #F74976;
                }
            }
        }

        .li-2 {
            padding-left: .27rem;

            span {
                color: #6E1C1C;
                font-size: 0.22rem;
                font-weight: 600;
            }
        }

        .li-3 {
            margin: 0 auto;
            margin-top: .8rem;
            width: 7.16rem;
            height: 1.1rem;

            img {
                width: 7.16rem;
                height: 1.1rem;
            }
        }

        .li-4 {
            font-size: 0.24rem;
            color: #D12E58;
            padding-left: .4rem;
            margin-top: .1rem;
        }
    }

}
</style>




// WEBPACK FOOTER //
// src/pages/market/market103.vue